import { Injectable } from '@angular/core';
import { Store, StoreConfig } from '@datorama/akita';

export interface UserDataState {
  key: string;
  userInviteNumber: number;
  invitedUsers: any[];
  eventsResults: any[];
}

export function createInitialState(): UserDataState {
  return {
    key: 'value',
    userInviteNumber: 0,
    invitedUsers: [],
    eventsResults: [],
  };
}

@Injectable({ providedIn: 'root' })
@StoreConfig({ name: 'user-data', resettable: true })
export class UserDataStore extends Store<UserDataState> {
  constructor() {
    super(createInitialState());
  }
}
